import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";

// Layouts
import DashboardLayout from "./layouts/DashboardLayout";
import AuthLayout from "./layouts/AuthLayout";

// Auth Pages
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import RegistrationGuard from "./components/auth/RegistrationGuard";

// Admin Pages
import AdminDashboard from "./pages/admin/AdminDashboard";
import BookManagement from "./pages/admin/BookManagement";
import UserManagement from "./pages/admin/UserManagement";
import Categories from "./pages/admin/Categories";
import Settings from "./pages/admin/Settings";
import VideosManagement from "./pages/admin/VideosManagement";

// Dashboard Pages
import Dashboard from "./pages/dashboard/Dashboard";
import BookList from "./pages/books/BookList";
import BookReader from "./pages/books/BookReader";
import Profile from "./pages/dashboard/Profile";
import VideoList from "./pages/videos/VideoList";
import VideoReader from "./pages/videos/VideoReader";

const AppRoutes = () => {
  const { isAuthenticated, loading, user } = useAuth();
  const isAdmin = user?.role === "admin";

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/auth"
        element={
          !isAuthenticated ? <AuthLayout /> : <Navigate to="/dashboard" />
        }
      >
        <Route path="login" element={<Login />} />
        <Route
          path="register"
          element={
            <RegistrationGuard>
              <Register />
            </RegistrationGuard>
          }
        />
        <Route path="" element={<Navigate to="/auth/login" />} />
      </Route>

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          isAuthenticated ? <DashboardLayout /> : <Navigate to="/auth/login" />
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="books" element={<BookList />} />
        <Route path="books/:id" element={<BookReader />} />
        <Route path="videos" element={<VideoList />} />
        <Route path="videos/:id" element={<VideoReader />} />
        <Route path="profile" element={<Profile />} />

        {/* Admin Routes */}
        {isAdmin && (
          <>
            <Route path="admin_dashboard" element={<AdminDashboard />} />
            <Route path="admin/users" element={<UserManagement />} />
            <Route path="admin/settings" element={<Settings />} />
            <Route path="admin/books_management" element={<BookManagement />} />
            <Route
              path="admin/videos_management"
              element={<VideosManagement />}
            />
            <Route path="admin/categories" element={<Categories />} />
          </>
        )}

        <Route path="" element={<Navigate to="/dashboard" />} />
      </Route>

      {/* Fallback Route */}
      <Route
        path="*"
        element={
          <Navigate to={isAuthenticated ? "/dashboard" : "/auth/login"} />
        }
      />
    </Routes>
  );
};

export default AppRoutes;

